import { gql } from 'apollo-angular';
import { pageInfoFragment } from '@shared/services/common/fragments/page-info.fragment';
import { productFragment } from './product.fragment';
import { companyBaseFragment } from '@shared/services/company/fragments/company-base.fragments';

export const productsPageFragment =  gql`
  fragment productsPage on ProductPage {
    totalCount
    edges {
      cursor
      node {
        ...product
        company(lang: $lang) @include(if: $includeCompany) {
          ...companyBase
        }
      }
    }
    pageInfo {
        ...pageInfo
    }
  }
  ${productFragment},
  ${pageInfoFragment},
  ${companyBaseFragment}
  `;
